import { render, staticRenderFns } from "./auth.component.vue?vue&type=template&id=551bd690&scoped=true"
import script from "./auth.component.vue?vue&type=script&lang=js"
export * from "./auth.component.vue?vue&type=script&lang=js"
import style0 from "./auth.component.vue?vue&type=style&index=0&id=551bd690&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551bd690",
  null
  
)

export default component.exports